import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { InspectionsPage } from '@/features/quality/inspections-page';

const searchSchema = z.object({
  inspection: z.string().optional().catch(undefined),
  new: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/safety/walks/')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <InspectionsPage
      projectId={projectId}
      category="safety"
      inspectionId={search.inspection}
      create={search.new}
    />
  );
}
